import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { authAPI } from '@/services/api';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { CheckCircle2, XCircle, Loader2 } from 'lucide-react';

export default function VerifyEmail() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('loading'); // loading | success | error
  const [message, setMessage] = useState('');

  useEffect(() => {
    let mounted = true;
    const verify = async () => {
      try {
        const res = await authAPI.verifyEmail(token);
        if (!mounted) return;
        setStatus('success');
        setMessage(res.data.message || 'Email verified successfully');
      } catch (err) {
        if (!mounted) return;
        setStatus('error');
        setMessage(err.response?.data?.message || 'Verification failed');
      }
    };
    verify();
    return () => { mounted = false; };
  }, [token]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-4">
      <Card className="w-full max-w-md">
        <CardContent className="pt-6 text-center space-y-4">
          {status === 'loading' && (
            <>
              <Loader2 className="w-12 h-12 mx-auto animate-spin text-primary" />
              <p className="text-muted-foreground">Verifying your email...</p>
            </>
          )}
          {status === 'success' && (
            <>
              <CheckCircle2 className="w-12 h-12 mx-auto text-green-500" />
              <h2 className="text-xl font-bold">{message}</h2>
              <p className="text-muted-foreground">You can now use all features of your account.</p>
              <Button onClick={() => navigate('/login')}>Go to Login</Button>
            </>
          )}
          {status === 'error' && (
            <>
              <XCircle className="w-12 h-12 mx-auto text-destructive" />
              <h2 className="text-xl font-bold">Verification Failed</h2>
              <p className="text-muted-foreground">{message}</p>
              <Button variant="outline" onClick={() => navigate('/login')}>Go to Login</Button>
            </>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
